import { render } from "./client-profile-tab.vue?vue&type=template&id=26a9391b"
import script from "./client-profile-tab.vue?vue&type=script&lang=js"
export * from "./client-profile-tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__